import { AiAgentPlugin } from './ai-agent-plugin'

export { AiAgentPlugin }
export default AiAgentPlugin
